module.exports = __webpack_public_path__ + "static/img/pay-icon05.89598383.svg";